import { Issue } from './Issue';

export type JiraField =
  | 'summary'
  | 'issuetype'
  | 'status'
  | 'assignee'
  | 'priority'
  | 'project'
  | 'description'
  | 'created';

export const defaultFilters: JQLFilters = {
  text: '',
  projects: [],
  statuses: [],
  issueIds: [],
  orderBy: '',
};

export const DEFAULT_JIRA_FIELDS: Array<JiraField> = [
  'summary',
  'issuetype',
  'project',
  'status',
];
export const DEFAULT_MAX_RESULTS = 100;

export const MAX_CONCURRENT_REQUESTS = 10;
export const MAX_RESULTS_WIHOUT_FIELDS = 5000;

export const SAFE_GUARD_TIMEOUT = 500;
export const REQUESTS_BETWEEN_SAFE_GUARD = 10;

export type IssueSearchResponse = {
  issues: Array<Issue>;
  nextPageToken?: string; //cloud
  total?: number; //server
};

export type IssueIdSearchResponse = {
  issues: Array<{ id: string }>;
  nextPageToken: string;
};

export type IssueCountByJQLResponse = {
  count: number;
};

export type IssueExpandField =
  | 'renderedFields'
  | 'schema'
  | 'names'
  | 'transitions'
  | 'operations'
  | 'editmeta'
  | 'changelog'
  | 'versionedRepresentations';

export type BulkFetchParameters = {
  ids: Array<number | string>;
  maxResults?: number;
  fields?: Array<string>;
  expand?: Array<IssueExpandField>;
};

export type GetIssuePageByJQLParams = {
  jql: string;
  retry?: boolean;
  expand?: Array<IssueExpandField>;
  fields?: Array<JiraField>;
  startAt?: number; //server
  maxResults?: number;
  nextPageToken?: string; ///cloud
};

export type GetAllIssuesByJQL = {
  jql: string;
  fields?: Array<JiraField>;
  expand?: Array<IssueExpandField>;
};

export type QAlityFilterestTestCasesParams = {
  startAt?: number; //server
  nextPageTokenForSearchByText?: string; //cloud
  nextPageTokenForSearchByKeys?: string; //cloud
  maxResults?: number;
  filters?: JQLFilters;
};

export type IssuesAndTotal = {
  issues: Issue[];
  total: number;
};

export type JQLFilters = {
  text?: string;
  projects?: Array<string>;
  statuses?: Array<string>;
  issueIds?: Array<number>;
  orderBy?: string;
};
